// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1S5rJ","cell":"ColumnAccessor_cell__deL3_","firstCellAccent":"ColumnAccessor_firstCellAccent__3sWHz"};